import React from "react";
import { CfdiForm } from "../cfdis/CfdiForm";

export default function CfdiIssuedForm() {
    return (
        <CfdiForm mode="cfdi-issued" />
    );
}